import {useCallback, useRef, useState} from "react";

export const TOOLTIP_OPEN_DELAY_DEFAULT = 400;

export function useTooltip({
  openDelay = TOOLTIP_OPEN_DELAY_DEFAULT,
  closeDelay = undefined
}) {
  const anchorRef = useRef();

  const timeout = useRef();

  const [isOpen, setIsOpen] = useState(false);

  const openWithDelay = useCallback(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      setIsOpen(true);
    }, openDelay);
  }, [openDelay]);

  const closeWithDelay = useCallback(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      setIsOpen(false);
    }, closeDelay ?? openDelay / 2);
  }, [closeDelay, openDelay]);

  return {
    anchorRef,
    isTooltipOpen: isOpen,
    openTooltipWithDelay: openWithDelay,
    closeTooltipWithDelay: closeWithDelay
  };
}
